import { useRoundable } from "./useRoundable.mjs";
import { useColorable } from "./useColorable.mjs";
import { useSizeable } from "./useSizeable.mjs";
import { computed, ref, watch } from "vue";
import { formatDimension } from "@spoferan/spoferan-ts-core";
export const ButtonComponentEmits = ["click", "update:loading"];
export function useButtonComponent(props, emit) {
  const { roundableString } = useRoundable(props);
  const { sizeableString } = useSizeable(props);
  const { colorClass, colorModifierClass, colorHex } = useColorable(props);
  const showLoadingIcon = ref(false);
  const buttonElement = ref(null);
  let loadingWidth = null;
  const isLoading = ref(props.loading);
  watch(isLoading, (loading) => {
    setLoadingIcon(loading);
    emit("update:loading", loading);
  });
  watch(() => props.loading, (loading) => {
    isLoading.value = loading;
  });
  const isDisabled = computed(() => {
    return isLoading.value || props.disabled;
  });
  const style = computed(() => {
    const style2 = {};
    if (colorHex.value && (props.outlined || props.text)) {
      style2.color = colorHex.value;
    }
    if (colorHex.value && !props.outlined && !props.text) {
      style2.backgroundColor = colorHex.value;
    }
    if (loadingWidth) {
      style2.width = formatDimension(loadingWidth);
      style2.maxWidth = formatDimension(loadingWidth);
    }
    return Object.keys(style2).length ? style2 : null;
  });
  function setLoadingIcon(isLoading2) {
    if (isLoading2) {
      loadingWidth = buttonElement.value ? buttonElement.value.getBoundingClientRect().width : null;
      showLoadingIcon.value = true;
    } else {
      loadingWidth = null;
      showLoadingIcon.value = false;
    }
  }
  return {
    style,
    isDisabled,
    showLoadingIcon,
    colorClass,
    colorModifierClass,
    colorHex,
    roundableString,
    sizeableString
  };
}
